module.exports = __webpack_public_path__ + "img/newmember_crown@2x.ce46917f.png";